import React from 'react';
import { IconButton } from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { Link } from 'react-router-dom';

interface DetailButtonInterface {
  link?: boolean;
  callbackFunction?: any;
  to?: string;
}

const DetailButton = ({
  link = false,
  callbackFunction = () => {
    // No-op: Default implementation
  },
  to = '',
}: DetailButtonInterface) => {
  return link ? (
    <IconButton component={Link} to={to} style={{ padding: 7 }}>
      <VisibilityIcon />
    </IconButton>
  ) : (
    <IconButton onClick={callbackFunction} style={{ padding: 7 }}>
      <VisibilityIcon />
    </IconButton>
  );
};

export default DetailButton;
